import styled from 'styled-components';

export const Wrapper = styled.a`
  display: inline-block;
  img {
    width: 100%;
  }
`;
